(ns quuppa.frontend-utils
  (:require [cljs.reader :as reader]))

(defn file->base64
  "Takes js/Blob and returns Promise that will resolve to map
  with the filename and Base64 encoded string of the file contents."
  [f]
  (js/Promise. (fn [done reject]
                 (let [reader (js/FileReader.)]
                   (.readAsDataURL reader f)
                   (set! (.-onload reader) (fn []
                                             (let [s (-> reader
                                                         (.-result)
                                                         (.toString)
                                                         (.replace #"^data:" "")
                                                         (.replace #"^.*," ""))
                                                   s (if (> (mod (count s) 4) 0)
                                                       (apply str s (repeat (mod (count s) 4) "="))
                                                       s)]
                                               (done {:filename (.-name f)
                                                      :data     s}))))
                   (set! (.-onerror reader) #(reject %))))))

(defonce ^:private -error-handler (atom nil))

(defn hide-react-duplicate-errors! []
  (swap! -error-handler
         (fn [v]
           (when v
             (.removeEventListener js/window "error" v))
           (let [f (fn [^js e]
                     ;; React duplicates some errors.
                     ;; Display the first one, and then ignore further error events of the same error.
                     ;; React throws additional errors as "uncaught errors" for debugger.
                     ;; Not sure if this breaks that.
                     (when (and (.-error e) (>= (some-> e .-error .-stack? (.indexOf "invokeGuardedCallbackDev")) 0))
                       (if (.-alreadySeen (.-error e))
                         (.preventDefault e)
                         (set! (.-alreadySeen (.-error e)) true))))]
             (.addEventListener js/window "error" f)
             f))))

(def default-preferences {:view "2d"
                          :hide-locators? false})
(defn get-item!
  "Get item from localStorage and returns it."
  [key]
  (let [value (or (->> key
                       (.getItem js/localStorage)
                       (reader/read-string))
                  default-preferences)]
    value))

(defn set-item!
  "Set item in localStorage and returns the value provided in argument."
  [key value]
  (->> (pr-str value)
       (.setItem js/localStorage key))
  value)

(defn remove-item!
  "Remove item from localStorage and returns the value which was stored inside."
  [key]
  (let [value (get-item! key)]
    (->> key
         (.removeItem js/localStorage))
    value))
